// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\np.overview[data-v-8c65c798] {\n  margin: 0 0 15px;\n}\n", ""]);
// Exports
module.exports = exports;
